import { Component, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { LoadingService } from '../../../services/loading.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-loading',
    imports: [CommonModule],
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements AfterViewInit {
    loadingTemplate: TemplateRef<any>;

    @ViewChild('spinnerTemplate', { static: false }) spinnerTemplate: TemplateRef<any>;

    constructor(public loadingService: LoadingService) {}

    ngAfterViewInit(): void {
        this.loadingService.setDefaultTemplate(this.spinnerTemplate);
    }
}
